import fPath from 'path';
import * as babelParser from '@babel/parser';
import traverseModle from '@babel/traverse';
import type { NodePath } from '@babel/traverse';
import generateModule from '@babel/generator';
import * as t from '@babel/types';
import type { TTransformer } from './type';
import {
  createJsxLocatorAttributes,
  getJSXTagName,
  hasInjectedDataAttributes,
  isFragmentElement,
  isSvgChild,
  shouldInjectTag,
} from './jsx-locator';
import { findWorkspaceRoot } from './utils';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const traverse = (traverseModle.default || traverseModle) as typeof traverseModle;
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const generate = (generateModule.default || generateModule) as typeof generateModule;

// --- JSX/TSX 处理 ---
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const transformJsx: TTransformer = (code: string, id: string, prefix: string, opts?: { attributes?: any; filterTag?: any }) => {
  const ast = babelParser.parse(code, {
    sourceType: 'module',
    plugins: ['jsx', 'typescript', 'classProperties', 'decorators-legacy'],
  });

  // 向上查找，直到找到名为 workspace 的目录
  const projectRoot = findWorkspaceRoot(process.cwd());
  const relativePath = fPath.relative(projectRoot, id);

  traverse(ast, {
    JSXOpeningElement(path) {
      const line = path.node.loc?.start.line;
      const startColumn = path.node.loc?.start.column;
      if (!line || startColumn === undefined) return;
      if (hasInjectedDataAttributes(path, prefix)) return;
      if (isFragmentElement(path)) return;
      if (isSvgChild(path)) return;

      const tagName = getJSXTagName(path.node.name);
      if (!shouldInjectTag(tagName, opts?.filterTag)) return;

      const attrResult = createJsxLocatorAttributes({
        code,
        path,
        prefix,
        relativePath,
        attributes: opts?.attributes,
      });
      if (!attrResult) return;

      // Find the index of the first spread attribute (e.g., {...props})
      // We insert our data attributes BEFORE the spread so that parent-passed
      // data attributes can override these defaults (enabling proper source tracking
      // for shared/common components)
      const spreadIndex = path.node.attributes.findIndex((attr) => t.isJSXSpreadAttribute(attr));

      const newAttrs = Object.entries(attrResult.attrs).map(([key, value]) => t.jsxAttribute(t.jsxIdentifier(key), t.stringLiteral(value)));

      if (spreadIndex === -1) {
        // No spread attribute found, append to the end as usual
        path.node.attributes.push(...newAttrs);
      } else {
        // Insert before the first spread attribute so parent attributes can override
        path.node.attributes.splice(spreadIndex, 0, ...newAttrs);
      }
    },
  });

  const output = generate(ast, {}, code);

  return {
    code: output.code,
    map: output.map,
  };
};
